import React, { useState, useEffect } from 'react';

import { NavLink } from 'react-router-dom';
import { Popover } from '@material-ui/core';

const BtnInmobiliaria: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div
      className="inmo"
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      <NavLink activeClassName="active-sublink" to="/servicios/inmobiliaria" className="inmo-link">
        <div className="inmo-content">
          <span className="inmo-triangle" />
          <span className="inmo-text">Proyecto en Venta</span>
        </div>
      </NavLink>
    </div>
  );
};

export default BtnInmobiliaria;
